module.exports = __webpack_public_path__ + "media/images/default-user-image-5f79ccbfa8c7feddad8fe9a18aa845a3.png";